import Vue from 'vue';

const pdpModule = {
  namespaced: true,

  state: {
    pdpSku: 0,
    priceData: {},
    isBike: false,
    rpaViewInStock: false,
    pdpDetailsLoaded: false,
    requestedProductCode: 0,
    searchResultReference: 0,
  },
  getters: {
    pdpBaseProductId: () => {
      const el = document.getElementById('base-code');
      if (!el) return null;

      return el.value;
    },
  },

  mutations: {
    setPdpSku(state, pdpSku) {
      Vue.set(state, 'pdpSku', pdpSku);
    },

    setPriceData(state, payload) {
      Vue.set(state, 'priceData', payload);
    },

    setIsBike(state, payload) {
      state.isBike = payload;
    },

    setRpaViewInStock(state, payload) {
      state.rpaViewInStock = payload;
    },

    setPdpDetailsLoaded(state, payload) {
      state.pdpDetailsLoaded = payload;
    },

    setRequestedProductCode(state, payload) {
      state.requestedProductCode = payload;
    },

    setSearchResultReference(state, payload) {
      state.searchResultReference = payload;
    },
  },

  actions: {
    setVariantPdpSku({commit}, pdpSku) {
      commit('setPdpSku', pdpSku);
    },

    setVariantPrice({commit}, priceData) {
      commit('setPriceData', priceData);
    },

    setRpaViewInStockModalValue({commit}, viewInStockValue) {
      commit('setRpaViewInStock', viewInStockValue);
    },
    updatePdpDetailsLoaded({commit}, pdpDetailsLoaded) {
      commit('setPdpDetailsLoaded', pdpDetailsLoaded);
    },
    updateRequestedProductCode({commit}, requestedProductCode) {
      commit('setRequestedProductCode', requestedProductCode);
    },
    updateSearchResultReference({commit}, searchResultReference) {
      commit('setSearchResultReference', searchResultReference);
    },
  },
};

export default pdpModule;
